import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/admin/AdminLayout';
import DataTable from '../../components/admin/DataTable';
import api from '../../utils/api';
import './UserListPage.css';

const UserListPage = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await api.get('/users');
      setUsers(res.data);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Are you sure you want to deactivate this user?')) return;
    try {
      await api.delete(`/users/${id}`);
      fetchUsers();
    } catch (error) {
      console.error('Failed to delete user:', error);
      alert('Failed to delete user');
    }
  };

  const columns = [
    { key: 'id', label: 'ID', width: '60px' },
    { key: 'username', label: 'Username' },
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    {
      key: 'role',
      label: 'Role',
      render: (row) => (
        <span className={`role-badge ${row.role.toLowerCase().replace('_', '-')}`}>
          {row.role === 'SUPER_MASTER' ? 'Super Master' : 'Master'}
        </span>
      ),
    },
    { key: 'locationId', label: 'Location', render: (row) => row.locationId || '-' },
    {
      key: 'active',
      label: 'Status',
      render: (row) => (
        <span className={`status-badge ${row.active ? 'confirmed' : 'cancelled'}`}>
          {row.active ? 'Active' : 'Inactive'}
        </span>
      ),
    },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="table-actions" onClick={(e) => e.stopPropagation()}>
          <button className="table-action-btn edit" onClick={() => navigate(`/admin/users/${row.id}`)}>Edit</button>
          {row.active && row.role !== 'SUPER_MASTER' && (
            <button className="table-action-btn delete" onClick={(e) => handleDelete(row.id, e)}>Deactivate</button>
          )}
        </div>
      ),
    },
  ];

  if (loading) {
    return <AdminLayout><div className="admin-loading">Loading...</div></AdminLayout>;
  }

  return (
    <AdminLayout>
      <div className="user-list-page">
        <div className="page-header-row">
          <h1>Users</h1>
          <button className="add-btn" onClick={() => navigate('/admin/users/new')}>
            + Add User
          </button>
        </div>
        <DataTable
          columns={columns}
          data={users}
          onRowClick={(row) => navigate(`/admin/users/${row.id}`)}
          emptyMessage="No users found"
        />
      </div>
    </AdminLayout>
  );
};

export default UserListPage;
